import styled from '@emotion/styled'
import { Heading, MediaQueries, theme } from '@hhgtech/hhg-components'
import { Carousel } from '@hhgtech/hhg-components/mantine'

export const StyledBabyPoopDetailVideoListWrapper = styled.div`
  margin-block: 40px;
  ${MediaQueries.mbDown} {
    margin-left: -16px;
    margin-right: -16px;
  }

  &[data-slide='2'] {
    margin-block: 0;
    display: flex;
    gap: 24px;
    > div {
      width: 100%;
    }
  }
`

export const StyledCarousel = styled(Carousel)`
  .mantine-Carousel-indicators {
    top: calc(100% + 1rem);
  }

  .mantine-Carousel-indicator {
    width: 8px;
    height: 8px;
    border-width: 0;
    opacity: 1;
    background-color: ${theme?.colors.neutral200};

    &[data-active] {
      background-color: ${theme?.colors.primaryBase};
    }
    .mantine-Carousel-control[data-inactive] {
      opacity: 0;
      cursor: 'default';
    }
  }
`

export const StyledHeading = styled(Heading)`
  margin-block: 20px;
  padding-left: 16px;
  border-left: 5px solid ${theme?.colors.primaryBase};
`
